import React from "react";
import Cookies from "js-cookie";
import { trackRubyPurchased } from "../../utils/metaPixelEvents";

interface payProps {
    closeModal: (status: boolean) => void;
    offerId: number;
    updateRubies: (rubies: number) => void;
    offerType: string;
}

export default function RazorPayBtn({
                                        closeModal,
                                        offerId,
                                        updateRubies,
                                        offerType,
                                    }: payProps) {
    async function getOrder() {
        const session_token = Cookies.get("c8_session_token");
        try {
            const orderResp = await fetch(
                `${process.env.API_URL}/offers/${offerId}/order?user_session=${session_token}`,
                {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                        "x-api-key": process.env.API_KEY as string,
                    },
                }
            );
            if (orderResp.status !== 201) {
                throw new Error("Error occured");
            }
            const resp = await orderResp.json();
            return resp;
        } catch (error) {
            console.error(error);
            closeModal(false);
            return;
        }
    }

    async function pay() {
        const orderDetails = await getOrder();
        if (!orderDetails || !orderDetails.id) {
            return;
        }
        const options = {
            key: process.env.RAZORPAY_KEY_ID,
            amount: orderDetails.amount,
            currency: orderDetails.currency,
            name: "Cricket 8",
            description: "Buy a ruby pack",
            image: "https://dyatkw7msrzcb.cloudfront.net/assets/image-1.png",
            order_id: orderDetails.id,
            theme: "#4b2c70",
            handler: function (response) {
                debugger
                onSuccess(orderDetails.receipt, response, orderDetails.amount / 100, orderDetails.currency);
            },
        };
        // @ts-ignore
        const rzp1 = new Razorpay(options);
        rzp1.open();
    }

    async function onSuccess(receiptId: string, response: any, amount: number, currency: string) {
        const session_token = Cookies.get("c8_session_token");
        try {
            const orderResp = await fetch(
                `${process.env.API_URL}/offers/${offerId}/receipt/${receiptId}/verify?user_session=${session_token}`,
                {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                        "x-api-key": process.env.API_KEY as string,
                    },
                    body: JSON.stringify(response),
                }
            );
            if (orderResp.status !== 200) {
                throw new Error("Error occured on verify");
            }
            const resp = await orderResp.json();

            trackRubyPurchased({
                user_id: session_token,
                purchase_amount: amount,
                currency: currency
            });

            closeModal(true);
            updateRubies(resp.wallet.rubies);
        } catch (error) {
            console.error(error);
            closeModal(false);
            return;
        }
    }

    return (
        <div className="w-[100%] p-2 h-[50px] mb-[20px] flex flex-row justify-center items-center">
            <button
                style={{
                    width: "240px",
                    height: "45px",
                    textAlign: "center",
                    backgroundColor: "#D2FF00",
                    color: "#1B062F",
                    fontFamily: "anton",
                }}
                onClick={pay}
            >
                Pay
            </button>
        </div>
    );
}
